import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { useOnboardingStore as useCoreOnboardingStore } from '@flows.cash/core'
import { toast } from 'sonner'

interface OnboardingState {
  isComplete: boolean
  fullName: string
  displayName: string
  dateFormat: string
  timeFormat: string
  language: string
  hasCheckedProfile: boolean
  setComplete: (value: boolean) => void
  updateUserInfo: (info: Partial<OnboardingState>, userId: string) => Promise<void>
  checkUserProfile: (userId: string) => Promise<boolean>
  reset: () => void
  cleanup: () => void
}

const initialState = {
  isComplete: false,
  fullName: '',
  displayName: '',
  dateFormat: 'MM/dd/yyyy',
  timeFormat: '12',
  language: 'en',
  hasCheckedProfile: false
}

export const useOnboardingStore = () => {
  const coreStore = useCoreOnboardingStore()
  
  return {
    ...coreStore,
    
    updateUserInfo: async (info: Parameters<typeof coreStore.updateUserInfo>[0], userId: string) => {
      try {
        await coreStore.updateUserInfo(info, userId)
        toast.success('Profile updated successfully')
      } catch (error) {
        toast.error('Failed to update profile')
        throw error
      }
    },
    
    checkUserProfile: async (userId: string) => {
      try {
        return await coreStore.checkUserProfile(userId)
      } catch (error) {
        toast.error('Failed to check profile')
        throw error
      }
    }
  }
} 